<template>
  <div>
    <!--visitSource = 2  PC端 -->
    <el-form v-if="visitSource == 2  || visitSource == 3" ref="kw_search_form" label-width="110px" label-suffix=":" label-position="right" size="mini" @submit.native.prevent>
      <div class="kw_search_pc">
        <!-- 直接显示的搜索条件 -->
        <el-row :gutter="10" style="margin-left:5px;margin-right:5px;" >
          <template v-for="(item,index) in outFieldArr" >
            <el-col v-if="item.styleSet.showStyle !=9" :key="'kw_search_'+index" :xl="(!item.styleSet || item.styleSet.showStyle == null || item.styleSet.showStyle == 1)?6:24" :lg="(!item.styleSet || item.styleSet.showStyle == null || item.styleSet.showStyle == 1)?8:24" :md="(!item.styleSet || item.styleSet.showStyle == null || item.styleSet.showStyle == 1)?12:24" :sm="24" :xs="24" :class="''"  :style="((item.styleSet.showStyle == 6 || item.styleSet.showStyle == 7)?'display:inline-block;height: 30px; margin-top: 5px;':((item.styleSet.showStyle == null || item.styleSet.showStyle == 1)?'height: 30px; margin-top: 5px;':'')) + (pageUtils.styleSetCodeZdy(item.styleSet.searchFieldForStyleSet,item))" kwName="searchFieldForStyleSet">
              <!-- 默认样式 -->
              <el-form-item v-if="(!item.styleSet || !item.styleSet.showStyle || item.styleSet.showStyle == 1)" :style="item.styleSet.searchFieldStyleSet?item.styleSet.searchFieldStyleSet.styleSetCode:''" kwName="searchFieldStyleSet">
                <span slot="label" v-if="(!item.styleSet.searchNameHide || item.styleSet.searchNameHide == 2)" :style="item.styleSet.searchFieldNameStyleSet?item.styleSet.searchFieldNameStyleSet.styleSetCode:''" kwName="searchFieldNameStyleSet">
                  {{item.fieldCnName}}:
                </span>
                <template v-if="(item.fieldType==1 && item.tcPageId==0)" >
                  <el-input v-model="item.startValue" :placeholder="'最小值:'+item.fieldCnName" @blur="bindElementChange(item)" @keyup.enter.native="bindElementChangeLoad(item)"  :style="'width:48%;' + (item.styleSet.searchFieldValueStyleSet?item.styleSet.searchFieldValueStyleSet.styleSetCode:'')" kwName="searchFieldValueStyleSet" class="kw_search_default"></el-input>
                  <el-input v-model="item.endValue" :placeholder="'最大值:'+item.fieldCnName" @blur="bindElementChange(item)" @keyup.enter.native="bindElementChangeLoad(item)"  :style="'width:48%;float: right;' + (item.styleSet.searchFieldValueStyleSet?item.styleSet.searchFieldValueStyleSet.styleSetCode:'')" kwName="searchFieldValueStyleSet" class="kw_search_default"></el-input>
                </template>
                <template v-else-if="(item.fieldType==2)" >
                  <el-input v-model="item.defaultValStr" :placeholder="'请输入:'+item.fieldCnName" @blur="bindElementChange(item)" @keyup.enter.native="bindElementChangeLoad(item)" :style="(item.styleSet.searchFieldValueStyleSet?item.styleSet.searchFieldValueStyleSet.styleSetCode:'')" kwName="searchFieldValueStyleSet" class="kw_search_default"></el-input>
                </template>
                <!-- 日期类型搜索 -->
                <template v-else-if="(item.fieldType==3)" >
                  <!-- <div class="dateFlex"> -->
                    <el-date-picker v-if="item.dataTypeXcx == 'date' || !item.dataTypeXcx" v-model="item.startDateObject" :type="item.dateFields=='day'?'date':item.dateFields" :format="item.dateType" :placeholder="'起始:'+item.fieldCnName" @change="bindElementChange(item)" @keyup.enter.native="bindElementChangeLoad(item)" :style="'width:48%;float: left;margin:1px 0 0 0;' + (item.styleSet.searchFieldValueStyleSet?item.styleSet.searchFieldValueStyleSet.styleSetCode:'')" kwName="searchFieldValueStyleSet" class="kw_search_default" clearable></el-date-picker>
                    <el-time-picker v-else-if="item.dataTypeXcx == 'time'" v-model="item.startDateObject" :format="item.dateType" :value-format="item.dateType" :placeholder="'起始:'+item.fieldCnName" @change="bindElementChange(item)" @keyup.enter.native="bindElementChangeLoad(item)" :style="'width:48%;float: left;margin:1px 0 0 0;' + (item.styleSet.searchFieldValueStyleSet?item.styleSet.searchFieldValueStyleSet.styleSetCode:'')" kwName="searchFieldValueStyleSet" class="kw_search_default" clearable></el-time-picker>
                    <el-date-picker v-else v-model="item.startDateObject" type="datetime" :format="item.dateType" :placeholder="'起始:'+item.fieldCnName" @change="bindElementChange(item)" @keyup.enter.native="bindElementChangeLoad(item)" :style="'width:48%;float: left;margin:1px 0 0 0;' + (item.styleSet.searchFieldValueStyleSet?item.styleSet.searchFieldValueStyleSet.styleSetCode:'')" kwName="searchFieldValueStyleSet" class="kw_search_default" clearable></el-date-picker>
                  <!-- </div>
                  <div class="allDate"> -->
                    <el-date-picker v-if="item.dataTypeXcx == 'date' || !item.dataTypeXcx" v-model="item.endDateObject" :type="item.dateFields=='day'?'date':item.dateFields" :format="item.dateType" :placeholder="'结束:'+item.fieldCnName" @change="bindElementChange(item)" @keyup.enter.native="bindElementChangeLoad(item)" :style="'width:48%;float: right;' + (item.styleSet.searchFieldValueStyleSet?item.styleSet.searchFieldValueStyleSet.styleSetCode:'')" kwName="searchFieldValueStyleSet" class="kw_search_default" clearable></el-date-picker>
                    <el-time-picker v-else-if="item.dataTypeXcx == 'time'" v-model="item.endDateObject" :format="item.dateType" :value-format="item.dateType" :placeholder="'结束:'+item.fieldCnName" @change="bindElementChange(item)" @keyup.enter.native="bindElementChangeLoad(item)" :style="'width:48%;float: right;' + (item.styleSet.searchFieldValueStyleSet?item.styleSet.searchFieldValueStyleSet.styleSetCode:'')" kwName="searchFieldValueStyleSet" class="kw_search_default" clearable></el-time-picker>
                    <el-date-picker v-else v-model="item.endDateObject" type="datetime" :format="item.dateType" :placeholder="'结束:'+item.fieldCnName" @change="bindElementChange(item)" @keyup.enter.native="bindElementChangeLoad(item)" :style="'width:48%;float: right;' + (item.styleSet.searchFieldValueStyleSet?item.styleSet.searchFieldValueStyleSet.styleSetCode:'')" kwName="searchFieldValueStyleSet" class="kw_search_default" clearable></el-date-picker>
                  <!-- </div> -->
                </template>
                <template v-else-if="(item.fieldType==4 || item.tcPageId>0)">
                  <!-- 下拉框 -->
                  <template v-if="item.chooseType==2 || item.tcPageId==0">
                    <el-select v-if="item.dicList.length > 2" multiple collapse-tags v-model="item.defaultCheckIndexArr" :placeholder="'请选择:'+item.fieldCnName" @change="bindElementChange(item,1)" :style="'width:100%;' + (item.styleSet.searchFieldValueStyleSet?item.styleSet.searchFieldValueStyleSet.styleSetCode:'')" kwName="searchFieldValueStyleSet" class="kw_search_default" clearable >
                      <template v-for="(dicItem,dicIndex) in item.dicList">
                        <el-option v-if="((!item.styleSet.filterParent && item.styleSet.filterParent!=0) || outFieldArr[item.styleSet.filterParent].defaultCheckValue == twoInfo.FILTER_ID)" :key="dicIndex" :label="dicItem.DIC_NAME" :value="dicIndex" >
                        </el-option>
                      </template>
                    </el-select>
                    <el-checkbox-group v-else  v-model="item.defaultCheckIndexArr" @change="bindElementChange(item,1)" class="checkGroups kw_search_default"  kwName="searchFieldValueStyleSet">
                      <template v-for="(twoInfo,twoIndex) in item.dicList">
                        <el-checkbox v-if="((!item.styleSet.filterParent && item.styleSet.filterParent!=0) || outFieldArr[item.styleSet.filterParent].defaultCheckValue == twoInfo.FILTER_ID)" :key="'dic_'+twoIndex" :label="twoIndex">{{twoInfo.DIC_NAME}}</el-checkbox>
                    </template>
                    </el-checkbox-group>
                  </template>
                  <!-- 弹出层 -->
                  <template v-else>
                    <el-input @click.native="openChangeDialog(item)" :style="('width:100%;') + (item.styleSet.searchFieldValueStyleSet?item.styleSet.searchFieldValueStyleSet.styleSetCode:'')" kwName="searchFieldValueStyleSet" class="kw_search_default" :value="(item.defaultCheckCnName?item.defaultCheckCnName:'点击选择')">
                      {{item.defaultCheckCnName?item.defaultCheckCnName:'点击选择'}}
                      <el-button slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                  </template>
                </template>
              </el-form-item>
              <!-- 下拉框 -->
              <!-- 标签搜索形式 -->
              <template v-else-if="(item.styleSet.showStyle == 2)">
                <!-- 上边线 -->
                <div style="border-top:1px solid #F6F6F6" v-if="(item.styleSet.showLine==1)"></div>
                <div :class="((item.styleSet.searchNameHide == 2?'tabTitleBox':item.styleSet.tabLine==8?'filletBox':item.styleSet.canScrollTip!=1?'tabBox hasScrollTip':'tabBox'))" :style="item.styleSet.searchFieldStyleSet?item.styleSet.searchFieldStyleSet.styleSetCode:''" kwName="searchFieldStyleSet">
                  <div class="tabName" v-if="(item.styleSet.searchNameHide == 2)" :style="item.styleSet.searchFieldNameStyleSet?item.styleSet.searchFieldNameStyleSet.styleSetCode:''" kwName="searchFieldNameStyleSet">{{item.fieldCnName}}:</div>
                  <div :style="'flex: 1 1 auto;overflow: hidden;position:relative;'+ (item.styleSet.searchFieldTabsBoxCommonStyleSet?item.styleSet.searchFieldTabsBoxCommonStyleSet.styleSetCode:'')" kwName="searchFieldTabsBoxCommonStyleSet" :class="(item.styleSet.ifShowBottomLine==1?'botLine':'')">
                    <kw_tabs v-model="item.defaultCheckValue" scroll @change="bindTabChange" :tabsStyleSet="pageUtils.styleSetCodeZdy(item.styleSet.searchFieldTabsCommonStyleSet,item)" kwName="searchFieldTabsCommonStyleSet">
                      <template v-for="(twoInfo,twoIndex) in item.dicList">
                        <kw_tab v-if="((!item.styleSet.filterParent && item.styleSet.filterParent!=0) || outFieldArr[item.styleSet.filterParent].defaultCheckValue == twoInfo.FILTER_ID || twoInfo.DIC_ID == 0)"  :key="'dic_'+twoIndex" :class="(item.styleSet.nameTopImg&&item.styleSet.nameTopImg==1?'newUpImg':'')" :name="(twoInfo.DIC_ID+'')" :oneIndex="(index)" :index="(twoIndex+'_'+twoInfo.ZD_IF_HD)" :title="(twoInfo.DIC_NAME)" :type="item.styleSet.newTabLine?item.styleSet.newTabLine:''" :bgFile="(item.styleSet.nameTopImg&&item.styleSet.nameTopImg==1?GLOBAL.getFileServeUrl()+twoInfo.BG_FILE:'')" :fileType="(twoInfo.ZD_IF_BJ+'')" :tabBoxStyle="pageUtils.styleSetCodeZdy(item.styleSet.searchFieldTabCommonStyleSet,twoInfo)" :tabDefaultStyle="pageUtils.styleSetCodeZdy(item.styleSet.searchFieldTabDefaultCommonStyleSet,twoInfo)" :tabCheckStyle="pageUtils.styleSetCodeZdy(item.styleSet.searchFieldTabCheckCommonStyleSet,twoInfo)" :definehover="pageUtils.styleSetCodeZdy(item.styleSet.lookTabsBoxCommonStyleSet,twoInfo)" kwName="searchFieldTabCommonStyleSet"></kw_tab>
                      </template>
                    </kw_tabs>
                  </div>
                  <div class="scrollTipImg" v-if="(item.styleSet.canScrollTip==2 && identification!=2)">
                    <img src="./img/scrollLeftAndRight.png" mode="widthFix"/>
                    <div class="more">更多</div>
                  </div>
                </div>
                <!-- 下边线 -->
                <div style="border-top:1px solid #F6F6F6" v-if="(item.styleSet.showLine==2)"></div>
              </template>
              <!--日历（周）  -->
              <template v-else-if="(item.styleSet.showStyle == 3)">
                <kw_weekly_calendar v-model="outFieldArr[index]" :index="index" :htPageDataInfo="htPageDataInfo" @setShowDataFilter="setShowDataFilter" @bindElementChangeNextLoad="bindElementChangeNextLoad" ></kw_weekly_calendar>
              </template>
              <!--日历（月）  -->
              <template v-else-if="(item.styleSet.showStyle == 4)">
                <kw_calendar ref="kw_calendar" v-model="outFieldArr[index]" calendar-style="calendar"  header-style="calendar-header"  board-style="calendar-board" :daysColor="dayStyle" weeksType="cn" @dayClick="dayClick" @dateChange="dateChange" @nextMonth="changeMonth" @prevMonth="changeMonth"/>
              </template>
              <!-- 全局搜索组件 -->
              <template v-else-if="(item.styleSet && item.styleSet.showStyle == 5)">
                <div v-if="item.styleSet.searchIconHide == 3" @click="openSearchDialog(item)" :style="'position:relative' + (item.styleSet.searchFieldStyleSet?item.styleSet.searchFieldStyleSet.styleSetCode:'')" kwName="searchFieldStyleSet">
                  <kw_icon :style="item.styleSet.searchFieldIconStyleSet?item.styleSet.searchFieldIconStyleSet.styleSetCode:''" kwName="searchFieldIconStyleSet" class="iconSearch" type="search" size=24 ></kw_icon>
                </div>
                <div v-else class="searchIptBox" :style="(item.styleSet.searchFieldStyleSet?item.styleSet.searchFieldStyleSet.styleSetCode:'')" kwName="searchFieldStyleSet">
                  <div @click="openSearchDialog(item)"  class="searchIpt" :style="(item.styleSet.searchFieldValueStyleSet?item.styleSet.searchFieldValueStyleSet.styleSetCode:'')" kwName="searchFieldValueStyleSet"><kw_icon class="iconSearch" type="search" size=20 :style="item.styleSet.searchFieldIconStyleSet?item.styleSet.searchFieldIconStyleSet.styleSetCode:''" kwName="searchFieldIconStyleSet"></kw_icon>点击打开搜索</div>
                </div>
              </template>
              <!-- 输入搜索组件 -->
              <template v-else-if="(item.styleSet && item.styleSet.showStyle == 6)">
                <div :class="(item.styleSet.searchNameHide == 2?'SearchFrame':'')" :style="(item.styleSet.searchFieldStyleSet?item.styleSet.searchFieldStyleSet.styleSetCode:'')" kwName="searchFieldStyleSet">
                  <div class="tabNameInput" v-if="(item.styleSet.searchNameHide == 2)" :style="item.styleSet.searchFieldNameStyleSet?item.styleSet.searchFieldNameStyleSet.styleSetCode:''" kwName="searchFieldNameStyleSet">{{item.fieldCnName}}:</div>
                  <div class="iptPart" :style="(item.styleSet.searchFieldValueStyleSet?item.styleSet.searchFieldValueStyleSet.styleSetCode:'')" kwName="searchFieldValueStyleSet">
                    <el-input v-if="(item.styleSet.searchIconHide!=2)"
                              :placeholder="(item.styleSet.searchPlaceholder?item.styleSet.searchPlaceholder:'输入搜索内容')"
                              v-model="item.defaultValStr"
                              @input="bindElementChange(item)" @keyup.enter.native="toInSearchDataClearOther(item,index)"  class="el_input_search"
                              :style="'width:'+(fullWidth-95)*1+'px;'+(item.styleSet.searchFieldInputStyleSet?item.styleSet.searchFieldInputStyleSet.styleSetCode:'')" kwName="searchFieldInputStyleSet">
                      <i slot="prefix" class="el-input__icon el-icon-search" style=""></i>
                    </el-input>
                    <input v-else  :style="item.styleSet.searchFieldInputStyleSet?item.styleSet.searchFieldInputStyleSet.styleSetCode:''" kwName="searchFieldInputStyleSet" class="searchInput" v-model="item.defaultValStr" @input="bindElementChange(item)" @keyup.enter="toInSearchDataClearOther(item,index)"   title="搜索内容" :placeholder="(item.styleSet.searchPlaceholder?item.styleSet.searchPlaceholder:'输入搜索内容')"  />
                    <button v-if="(pageSetInfo.searchStyleSet.searchButtonStyle == 3)" type="button"  class="searchAfterBtn" @click="toInSearchDataClearOther(item,index)">搜索</button>
                    <!-- :style="pageSetInfo.searchStyleSet.searchCommonStyleSet?pageSetInfo.searchStyleSet.searchCommonStyleSet.styleSetCode:''" kwName="searchCommonStyleSet" -->
                  </div>
                </div>
              </template>
              <!-- 下拉搜索组件 -->
              <div v-else-if="(item.styleSet.showStyle == 7)" :class="(item.styleSet.hasDevide==2?'rightDevid':'')" :style="item.styleSet.searchFieldStyleSet?item.styleSet.searchFieldStyleSet.styleSetCode:''" kwName="searchFieldStyleSet">
                <kw_select v-model="item.defaultCheckValue" :placeholder="item.fieldCnName" :clearable="true" :item="item" :filterId="item.styleSet.filterParent>=0?outFieldArr[item.styleSet.filterParent].defaultCheckValue:''" @dropdownItemChange="dropdownItemChange(item,index)" class="select_search"></kw_select>
              </div>
              <!-- 常用日期搜索 -->
              <div v-else-if="(item.styleSet.showStyle == 10)" :class="(item.styleSet.hasDevide==2?'rightDevid':'')" :style="'display:inline-block;box-sizing: border-box;margin: 10px;'+(item.styleSet.searchFieldStyleSet?item.styleSet.searchFieldStyleSet.styleSetCode:'')" kwName="searchFieldStyleSet">
                <div class="tabNameInput" v-if="(item.styleSet.searchNameHide == 2)" :style="'display: inline-block;' + (item.styleSet.searchFieldNameStyleSet?item.styleSet.searchFieldNameStyleSet.styleSetCode:'')" kwName="searchFieldNameStyleSet">{{item.fieldCnName}}:</div>
                <div :style="'overflow: auto;position:relative;background: #fff;display: inline-block;'" :class="(item.styleSet.ifShowBottomLine==1?'botLine':'')">
                  <kw_tabs v-model="item.showStyle10Value" scroll @change="showStyle10Change" :bg="(item.styleSet.tabsBg)" :radius="(item.styleSet.tabsRadius)" :align="(item.styleSet.tabAlign==1?'left':item.styleSet.tabAlign==2 || identification ==2 ?'center':item.styleSet.tabAlign==3?'right':'')">
                      <kw_tab :class="(item.styleSet.nameTopImg&&item.styleSet.nameTopImg==1?'newUpImg':'')" :name="'1'" :oneIndex="(index)" title="全部"></kw_tab>
                      <kw_tab :class="(item.styleSet.nameTopImg&&item.styleSet.nameTopImg==1?'newUpImg':'')" :name="'2'" :oneIndex="(index)" title="今日"></kw_tab>
                      <kw_tab :class="(item.styleSet.nameTopImg&&item.styleSet.nameTopImg==1?'newUpImg':'')" :name="'3'" :oneIndex="(index)" title="昨日"></kw_tab>
                      <kw_tab :class="(item.styleSet.nameTopImg&&item.styleSet.nameTopImg==1?'newUpImg':'')" :name="'4'" :oneIndex="(index)" title="近7天"></kw_tab>
                      <kw_tab :class="(item.styleSet.nameTopImg&&item.styleSet.nameTopImg==1?'newUpImg':'')" :name="'5'" :oneIndex="(index)" title="自定义"></kw_tab>
                  </kw_tabs>
                </div>
                <div v-if="(item.showStyle10Value==5)" class="dateFlex" style="display:inline-block;width:auto;vertical-align: top;">
                    <div style="display:inline-block;">
                      <el-date-picker v-if="item.dataTypeXcx == 'date'"
                                      v-model="item.startDateObject"
                                      :type="item.dateFields=='day'?'date':item.dateFields"
                                      :format="item.dateType"
                                      placeholder="选择开始"
                                      @blur="bindElementChangeLoad(item)" clearable
                      >
                      </el-date-picker>
                      <el-time-picker v-else-if="item.dataTypeXcx == 'time'"
                                      v-model="item.startDateObject"
                                      :format="item.dateType" :value-format="item.dateType"
                                      placeholder="选择开始"
                                      @blur="bindElementChangeLoad(item)" clearable
                      >
                      </el-time-picker>
                      <el-date-picker v-else
                                      v-model="item.startDateObject"
                                      type="datetime"
                                      :format="item.dateType"
                                      placeholder="选择开始"
                                      @blur="bindElementChangeLoad(item)" clearable
                      >
                      </el-date-picker>
                    </div>
                    <div class="allDate" style="display:inline-block;">
                      <el-date-picker v-if="item.dataTypeXcx == 'date'"
                                      v-model="item.endDateObject"
                                      :type="item.dateFields=='day'?'date':item.dateFields"
                                      :format="item.dateType"
                                      placeholder="选择结束"
                                      @blur="bindElementChangeLoad(item)" clearable
                      >
                      </el-date-picker>
                      <el-time-picker v-else-if="item.dataTypeXcx == 'time'"
                                      v-model="item.endDateObject"
                                      :format="item.dateType" :value-format="item.dateType"
                                      placeholder="选择结束"
                                      @blur="bindElementChangeLoad(item)" clearable
                      >
                      </el-time-picker>
                      <el-date-picker v-else
                                      v-model="item.endDateObject"
                                      type="datetime"
                                      :format="item.dateType"
                                      placeholder="选择结束"
                                      @blur="bindElementChangeLoad(item)" clearable
                      >
                      </el-date-picker>
                    </div>
                </div>
              </div>
              <!-- 标签轴搜索 -->
              <div v-else-if="(item.styleSet.showStyle == 11)" :style="item.styleSet.searchFieldStyleSet?item.styleSet.searchFieldStyleSet.styleSetCode:''" kwName="searchFieldStyleSet">
                <HorizonTimeLine :timelineData="item.dicList" :value="item" @change="bindElementChangeLoad(item)"></HorizonTimeLine>
              </div>
              <!-- 复选搜索 -->
              <div v-else-if="(item.styleSet.showStyle == 12)" :style="item.styleSet.searchFieldStyleSet?item.styleSet.searchFieldStyleSet.styleSetCode:''" kwName="searchFieldStyleSet">
                <el-checkbox-group v-model="item.defaultCheckIndexArr" size="medium" @change="bindElementChangeLoad(item,1)" :style="pageUtils.styleSetCodeZdy(item.styleSet.searchFieldTabsCommonStyleSet,item)" kwName="searchFieldTabsCommonStyleSet">
                  <template v-for="(twoInfo,twoIndex) in item.dicList">
                    <el-checkbox-button :label="twoIndex" :key="'check_12_'+twoIndex" :style="pageUtils.styleSetCodeZdy(item.styleSet.searchFieldTabCommonStyleSet,item,twoIndex) + (item.defaultCheckIndexArr.indexOf(twoIndex)?pageUtils.styleSetCodeZdy(item.styleSet.searchFieldTabCheckCommonStyleSet,item,twoIndex):'')" kwName="searchFieldTabDefaultCommonStyleSet">{{twoInfo.DIC_NAME}}</el-checkbox-button>
                  </template>
                </el-checkbox-group>
              </div>
            </el-col>
          </template>
          <el-col :span=8 v-if="outFieldArr.length > 0 && pageSetInfo.searchStyleSet && pageSetInfo.searchStyleSet.searchButtonStyle == 2">
            <el-button type="primary" class=""  @click="toInSearchData" :style="pageSetInfo.searchStyleSet.searchCommonStyleSet?pageSetInfo.searchStyleSet.searchCommonStyleSet.styleSetCode:''" kwName="searchCommonStyleSet">搜索</el-button>
          </el-col>
        </el-row>

        <span v-if="(inFieldArr.length > 0) && visitSource !=2"  @click="moreDropdownFnc" :class="moreDropdown?'colorRed':''" class="cleck_more">更多 <i :class="moreIcon" :style="moreDropdown?'color:#EE0A24':''"></i></span>
        <!-- 更多下拉筛选 -->
        <el-drawer
          title="更多筛选"
          :visible.sync="moreDropdown"
          :direction="'ttb'" size="70%">
          <div style="height: 80%;overflow: auto">
            <div v-for="(item,index) in inFieldArr" :key="'inField_'+index" class="moreDropdownTop">
              <el-form-item>
                <!-- <span slot="label" :style="item.styleSet.searchFieldNameStyleSet?item.styleSet.searchFieldNameStyleSet.styleSetCode:''" kwName="searchFieldNameStyleSet">
                  {{item.fieldCnName}}:
                </span> -->
                <div v-if="(item.fieldType==1 && item.tcPageId==0)" >
                  <el-input v-model="item.startValue" :placeholder="'最小值:'+item.fieldCnName" @blur="bindElementChange(item)" ></el-input>
                  <el-input v-model="item.endValue" :placeholder="'最大值:'+item.fieldCnName" @blur="bindElementChange(item)" ></el-input>
                </div>
                <div v-else-if="(item.fieldType==2)" >
                  <el-input v-model="item.startValue" :placeholder="'请输入:'+item.fieldCnName" @blur="bindElementChange(item)" ></el-input>
                </div>
                <!-- 日期类型搜索 -->
                <div v-else-if="(item.fieldType==3)" class="dateFlex" >
                  <div>
                    <el-date-picker v-if="item.dataTypeXcx == 'date'"
                                    v-model="item.startDateObject"
                                    :type="item.dateFields=='day'?'date':item.dateFields"
                                    :format="item.dateType"
                                    :placeholder="'开始:'+item.fieldCnName" 
                                    @blur="bindElementChange(item)" clearable
                    >
                    </el-date-picker>
                    <el-time-picker v-else-if="item.dataTypeXcx == 'time'"
                                    v-model="item.startDateObject"
                                    :format="item.dateType" :value-format="item.dateType"
                                    :placeholder="'开始:'+item.fieldCnName" 
                                    @blur="bindElementChange(item)" clearable
                    >
                    </el-time-picker>
                    <el-date-picker v-else
                                    v-model="item.startDateObject"
                                    type="datetime"
                                    :format="item.dateType"
                                    :placeholder="'开始:'+item.fieldCnName" 
                                    @blur="bindElementChange(item)" clearable
                    >
                    </el-date-picker>
                  </div>
                  <div class="allDate">
                    <el-date-picker v-if="item.dataTypeXcx == 'date'"
                                    v-model="item.endDateObject"
                                    :type="item.dateFields=='day'?'date':item.dateFields"
                                    :format="item.dateType"
                                    :placeholder="'结束:'+item.fieldCnName" 
                                    @blur="bindElementChange(item)" clearable
                    >
                    </el-date-picker>
                    <el-time-picker v-else-if="item.dataTypeXcx == 'time'"
                                    v-model="item.endDateObject"
                                    :format="item.dateType" :value-format="item.dateType"
                                    :placeholder="'结束:'+item.fieldCnName" 
                                    @blur="bindElementChange(item)" clearable
                    >
                    </el-time-picker>
                    <el-date-picker v-else
                                    v-model="item.endDateObject"
                                    type="datetime"
                                    :format="item.dateType"
                                    :placeholder="'结束:'+item.fieldCnName" 
                                    @blur="bindElementChange(item)" clearable
                    >
                    </el-date-picker>
                  </div>
                </div>
                <div v-else-if="(item.fieldType==4 || item.tcPageId>0)">
                  <el-checkbox-group  v-model="item.defaultCheckIndexArr" @change="bindElementChange(item,1)" class="checkGroups" >
                    <el-checkbox v-for="(twoInfo,twoIndex) in item.dicList" :key="'dic_'+twoIndex" :label="twoIndex" v-if="((!item.styleSet.filterParent && item.styleSet.filterParent!=0) || outFieldArr[item.styleSet.filterParent].defaultCheckValue == twoInfo.FILTER_ID)" >{{twoInfo.DIC_NAME}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-form-item>
            </div>
          </div>
          <el-button-group class="bottomBtn">
            <el-button class="cancel_btn" @click="cancelOutSearchData">取消</el-button>
            <el-button class="confirm_btn" @click="toOutSearchData">确定</el-button>
          </el-button-group>
        </el-drawer>
        <!-- <div v-show="moreDropdown" class="moreDropdownBox" :style="'width:'+fullWidth+'px'">
        </div> -->

      </div>

      <template v-for="(item,index) in outFieldArr" >
        <!-- 按钮标签 -->
        <template v-if="(item.styleSet.showStyle == 8)" >
          <div class="understandBtnBox" :key="'outBut_'+index">
            <div v-for="(twoInfo,twoIndex) in item.dicList" :key="'dic_'+twoIndex">
              <div v-if="((!item.styleSet.filterParent && item.styleSet.filterParent!=0) || outFieldArr[item.styleSet.filterParent].defaultCheckValue == twoInfo.FILTER_ID)">
                <div @click="buttonTabClick(item,twoInfo)" :style="item.styleSet.searchFieldStyleSet?item.styleSet.searchFieldStyleSet.styleSetCode:''" kwName="searchFieldStyleSet" class="understandBtn"><div style="display:flex;align-items:center;justify-content:center"><i :class="twoInfo.DIC_ICON" style="margin-top:1px"></i><text style="padding-left:2px;">{{twoInfo.DIC_NAME}}</text></div></div>
              </div>
            </div>
          </div>
        </template>
      </template>
    </el-form>
    <!-- 列表页面弹出层 -->
    <el-dialog class="zdy_dialog" v-if="dialogInfo.ifOpen"  :visible.sync="dialogInfo.ifOpen" title="选择" width="100%" top="1vh" append-to-body :close-on-click-modal="false" v-dialogDrag>
      <kw_list v-if="dialogInfo.ifOpen" ref="dialog_kw_list" :initPageObj="toListJson" @dialogClickCallBack="dialogClickCallBack" @closeDialog="closeDialog" :isLimitButton="isLimitButton" :ifDialog="1"></kw_list>
    </el-dialog>
  </div>

</template>

<script>
// kw_tabs 标签组组件
import kw_tabs from '@/components/kw/kw_tabs.vue';
// kw_tab 标签组件
import kw_tab from '@/components/kw/kw_tab.vue';
// kw_select 标签组件
import kw_select from '@/components/form/kw_select.vue';

// 图标库
import kw_icon from '@/components/kw/kw_icon.vue';

//周日历
import kw_weekly_calendar from '@/components/form/kw_weekly_calendar.vue';
//月日历
import kw_calendar from '@/components/kw/kw_calendar.vue';
// 弹出层组件
import kw_dialog_field from '@/components/look/kw_dialog_field.vue';
//标签轴组件
import HorizonTimeLine from '@/components/form/HorizonTimeLine.vue';


import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_search',
  props: {
    //页面设置信息
    pageSetInfo: {
      type: Object
    },
    initSearchVal:{
      type:String
    },
    htPageDataInfo:{
      type:Array,
      default:[]
    },
    mainId:{},
    //需要传递到后台的搜索条件
    value:{
      type:Object,
      default:function () {
        return {}
      }
    },
    previewVisitSource:{
      type:Number,
      default:0
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    },
  },
  data() {
    var that = this;
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(that),
//      窗口宽度
      fullWidth:document.documentElement.clientWidth,
      //默认显示的搜索条件
      outFieldArr:[],
      //默认收起的搜索条件
      inFieldArr:[],
      //是否打开搜索层
      ifOpenSearch:false,
      dayStyle: [
        { month: 'current', day: new Date().getDate(), color: 'white', background: '#FF7B04', numMark: 0}
      ],
      // 下拉菜单标题
      itemTitle: '更多',
      // 下拉菜单类型  是否带图标
      dropdown: 1,
      //是否显示更多提示
      identification: 0,
      //更多下拉筛选展开收起
      moreDropdown:false,
      //更多图标
      moreIcon:'el-icon-arrow-down',
      dialogInfo:{
        ifOpen:false,
        sourceField:null
      },
      // 弹出层组件的信息
      toListJson:{
      },
    };
  },
  created() {
    this.initAttached();
  },
  mounted() {
    
  },
  watch:{
    htPageDataInfo(){
      var val = this.htPageDataInfo;
      var outFieldArr = this.outFieldArr;
      var flag = false;
      // 日期月类型需要进行数据处理
      outFieldArr.forEach(one=>{
        if(one.styleSet.showStyle == 4){
          flag = true;
        }
      })
      if (flag) {
        var dayStyle = [];
        if (val) {
          var dataDayJson = {};
          var dayArr = [];
          val.forEach(one => {
            var arr = dataDayJson['day_' + one.DAY];
            if (!arr) {
              arr = [];
              dataDayJson['day_' + one.DAY] = arr;
              dayArr.push(one.DAY);
            }
            arr.push(one);
          })
          var nowDay = new Date().getDate();
          var flag = false;
          dayArr.forEach(one => {
            var arr = dataDayJson['day_' + one];
            if (one == nowDay) {
              dayStyle.push({ month: 'current', day: one, color: 'white', background: '#FF7B04', numMark: arr.length });
              flag = true;
            } else {
              dayStyle.push({ month: 'current', day: one, numMark: arr.length });
            }
          })
          if (!flag) {
            dayStyle.push({ month: 'current', day: nowDay, color: 'white', background: '#FF7B04', numMark: 0 });
          }
          nowDay = nowDay < 10 ? '0' + nowDay : nowDay;
          var e = {
            "DAY": nowDay
          }
          this.setShowDataFilter(e);
          this.dayStyle = dayStyle;
        }
      }
    }
  },
  computed:{
  },
  components: {
    kw_tabs,
    kw_tab,
    kw_select,
    kw_weekly_calendar,
    HorizonTimeLine,
    kw_calendar,
    kw_icon,
    kw_dialog_field,
    kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve)
  },
  methods: {
    //更多下拉筛选展开收起
    moreDropdownFnc(){
      this.moreDropdown = !this.moreDropdown
      if(this.moreDropdown == true){
        this.stop()
        this.moreIcon = 'el-icon-arrow-up'
      }else if(this.moreDropdown == false){
        this.move()
        this.moreIcon = 'el-icon-arrow-down'
      }
    },
    //进行组件加载时的逻辑处理
    initAttached(){
      var that = this;
      //循环页面设置的搜索条件 区分哪些搜索条件直接显示 哪些条件收起显示
      var pageSetInfo = that.pageSetInfo;
      var searchSet = pageSetInfo.fieldSet;
      var inFieldArr = pageSetInfo.inFieldArr;
      var outFieldArr = pageSetInfo.outFieldArr;
      that.outFieldArr = outFieldArr;
      that.inFieldArr = inFieldArr;
      that.getToHtData();
    },
    /**
     * 获取所有搜索条件需要组合成的传递到后台的json
     */
    getToHtData(){
      var that = this;
      var outFieldArr = that.outFieldArr;
      var inFieldArr = that.inFieldArr;
      var toHtData = {};
      var toHtData1 = pageUtils.initSearchListData(outFieldArr);
      var toHtData2 = pageUtils.initSearchListData(inFieldArr);
      for(var key in that.value){
          delete that.value[key];
      }
      that.value = Object.assign(that.value , toHtData1);
      that.value = Object.assign(that.value , toHtData2);
    },
    /**
     * 下拉组件切换时的方法
     */
    bindElementChange: function (nowField,dicType) {
      var that = this;
      var fieldType = nowField.fieldType;
      var tcPageId = nowField.tcPageId;
      if (fieldType == 1 && tcPageId == 0) {
        // 数字类型搜索条件
        pageUtils.bindInputBlur(that, nowField);
      } else if (fieldType == 2 && tcPageId == 0) {
        // 字符类型搜索条件
        pageUtils.bindInputBlur(that, nowField);
      } else if (fieldType == 3) {
        if(!nowField.dateType) {
          nowField.dateType = "yyyy-MM-dd";
        }
        if(typeof(nowField.startDateObject) == 'object') {
          if(nowField.startDateObject == null) {
            nowField.startDate = "";
          } else {
            nowField.startDate = pageUtils.dateFormat(nowField.startDateObject, nowField.dateType);
          }
        } else {
          nowField.startDate = nowField.startDateObject;
        }
        if(typeof(nowField.endDateObject) == 'object') {
          if(nowField.endDateObject == null) {
            nowField.endDate = "";
          } else {
            nowField.endDate = pageUtils.dateFormat(nowField.endDateObject, nowField.dateType);
          }
        } else {
          nowField.endDate = nowField.endDateObject;
        }
        console.log("nowField==========================",nowField);
        // 日期类型搜索条件
        pageUtils.bindDateChange(that, nowField);
      } else if (fieldType == 4 || tcPageId>0) {
        // 下拉框切换
        if (dicType == 1){
          pageUtils.bindPickerChange(that, nowField);
        } else {
          pageUtils.bindPickerChangeValue(that, nowField)
        }
      }
      that.getToHtData();
    },
    /**
     * 下拉组件(标签形式的)切换时的方法
     */
    bindTabChange(tab,event){
      var oneIndex = tab.oneIndex;
      var outFieldArr = this.outFieldArr;
      this.bindElementChange(outFieldArr[oneIndex]);
      // 判断是否有 根据当前这个元素进行过滤的搜索条件 
      this.cancelSeachFieldCheck(outFieldArr, 1, oneIndex);
      this.outFieldArr = outFieldArr;
//      this.triggerEvent('loadDataInfo');
      var nowIndex = tab.index;
      var indexArr = nowIndex.split("_")
      this.identification = indexArr[1] ? indexArr[1]:0;
      this.$emit('loadDataInfo');
    },
    /**
     * 切换列表的显示数据
     */
    setShowDataFilter: function (e){
//      this.triggerEvent("setShowDataFilter",e);
      this.$emit('setShowDataFilter',e)

    },
    /**
     * 清空搜索条件的选中
     * fieldList：需要清空的搜索条件数组
     * ifOnlyGl：是否只清除关联过滤 1:联动过滤清除  2:除了传递的 其他清除 0:清除所有
     * filterIndex:根据第几个搜索条件清除关联过滤
     */
    cancelSeachFieldCheck(fieldList,ifOnlyGl,filterIndex) {
      for (var i = 0; i < fieldList.length; i++) {
        var fieldOne = fieldList[i];
        var ifQk = true;
        if (ifOnlyGl == 1) {
          ifQk = false;
          // 如果有前一级的过滤条件 则只清空关联条件
          if (filterIndex >= 0) {
            if (fieldOne.styleSet && fieldOne.styleSet.filterParent == filterIndex) {
              ifQk = true;
            }
          }
        } else if (ifOnlyGl == 2) {
          if (i == filterIndex) {
            ifQk = false;
          }
        }
        if (ifQk) {
          fieldOne.defaultCheckValueIndex = null;
          fieldOne.defaultCheckValue = 0;
          fieldOne.defaultCheckCnName = "";
          fieldOne.defaultCheckIndexArr = [];
          fieldOne.defaultValStr = "";
          if (fieldOne.startDate) {
            fieldOne.startDate = "";
          }
          if (fieldOne.endDate) {
            fieldOne.endDate = "";
          }
          if (fieldOne.dicList) {
            for (var k = 0; k < fieldOne.dicList.length; k++) {
              fieldOne.dicList[k].CHECKED = false;
            }
          }
        }
      }
      return fieldList;
    },
    /**
     * 子组件调用父组件的 元素切换赋值方法
     */
    bindElementChangeNextLoad(){
      this.getToHtData();
      this.$emit("loadDataInfo");
    },
    /**
     * 跳转到 弹出层页面
     */
    openSearchDialog(nowField){
      //获取跳转的tableId和pageId
      var styleSet = nowField.styleSet;
      var clickTableId = styleSet.clickTableId;
      var clickPageId = styleSet.clickPageId;
      var mainId = pageUtils.getShamOpenId();
      if (styleSet) {
        //跳转到具体的列表页面   需要把搜索条件传递过去
        var toListJson = {
          pageId: clickPageId,
          tableId: clickTableId,
          initCheckId: 0,
          callBackType: 0,
          dataMaxNum: 1,
          mainId: mainId
        }
        
        // 传递列表页面的搜索条件的默认选中
        pageUtils.toNewListPage(this,toListJson);
      }
    },
    /**
     * 外部的搜索条件 同时清空其他条件 进行搜索时
     */
    toInSearchDataClearOther(fieldOne,index) {
      var outFieldArr = this.outFieldArr;
      var inFieldArr = this.inFieldArr;
      var defaultValStr = fieldOne.defaultValStr;
      // 搜索框输入内容为空时  检索出全部内容
      if (defaultValStr && defaultValStr.length > 0) {
        this.cancelSeachFieldCheck(outFieldArr, 2, index);
        this.cancelSeachFieldCheck(inFieldArr, 0);
        this.outFieldArr = outFieldArr;
        this.inFieldArr = inFieldArr;
      }
      this.$emit("loadDataInfo");
    },
    /**
     * 下拉搜索组件点击选中时 
     */
    dropdownItemChange:function(fieldOne,oneIndex){
      var outFieldArr = this.outFieldArr;
      this.bindElementChange(fieldOne);
      this.cancelSeachFieldCheck(outFieldArr, 1, oneIndex);
      this.$emit("loadDataInfo");
    },
    /**
     * 外部的搜索条件 进行搜索时
     */
    toOutSearchData(){
      this.$emit("loadDataInfo");
      // 关闭弹出层
      this.onConfirm();
    },
    // 关闭弹出层
    onConfirm() {
      this.moreDropdownFnc();
    },
    /**
     * 取消搜索时
     */
    cancelOutSearchData(){
      var inFieldArr = this.inFieldArr;
      if (inFieldArr) {
        this.cancelSeachFieldCheck(inFieldArr,0);
      }
      this.inFieldArr = inFieldArr;
      this.onConfirm();
    },
    /**
     * 外部的搜索条件 进行搜索时
     */
    toInSearchData() {
      this.$emit("loadDataInfo");
    },
    /**
     * 按钮标签点击事件
     */
    buttonTabClick:function(fieldOne,dicOne){
      pageUtils.openDynamicPage(dicOne);
    },
    /***阻止滚动限制***/
    stop(){
      var mo=function(e){passive: false ;};
      document.body.style.overflow='hidden';
      document.addEventListener("touchmove",mo,false);//禁止页面滑动
    },
    /***取消滚动限制***/
    move(){
      var mo=function(e){passive: false };
      document.body.style.overflow='';//出现滚动条
      document.removeEventListener("touchmove",mo,false);
    },
    //给点击的日期设置一个背景颜色
    dayClick: function (event) {
      var day = event.day;
      
      var dayStyle = this.dayStyle;
      var flag = false;
      dayStyle.forEach(one => {
        if (one.day == day) {
          one.color = 'white';
          one.background = '#FF7B04';
          flag = true;
        } else {
          one.color = '';
          one.background = '';
        }
      })
      if (!flag) {
        dayStyle.push({ month: 'current', day: day, color: 'white', background: '#FF7B04', numMark: 0 });
      }
      this.dayStyle = dayStyle;
      day = day < 10 ? '0' + day : day;
      var e = {
        "DAY": day
      }
      this.setShowDataFilter(e);
    },

    /**
     * 月份切换时
     */
    changeMonth: function (event) {
      var nowDay = new Date().getDate();
      nowDay = nowDay < 10 ? '0' + nowDay : nowDay;
      var dayE = {
        "DAY": nowDay
      }
      this.setShowDataFilter(dayE);
      this.bindElementChangeNextLoad();
    },

    /**
     * 日期切换事件
     */
    dateChange: function (event) {
      this.changeMonth(event);
    },
    /**
     * 常用日期搜索 切换时的触发事件
     */
    showStyle10Change:function(tab,event){
      var that = this;
      var nowDate = new Date();
      var oneIndex = tab.oneIndex;
      var outFieldArr = this.outFieldArr;
      var type = tab.name;
      var oneField = outFieldArr[oneIndex];
      if(type == 1) {
        // 全部
        oneField.startDate = "";
        oneField.endDate = "";
      } else if(type == 2) {
        // 今日
        var startDate = pageUtils.dateFormat(nowDate,'yyyy-MM-dd');
        oneField.startDate = startDate;
        oneField.endDate = startDate;
      } else if(type == 3) {
        nowDate.setDate(nowDate.getDate()-1);
        // 昨天
        var startDate = pageUtils.dateFormat(nowDate,'yyyy-MM-dd');
        oneField.startDate = startDate;
        oneField.endDate = startDate;
      } else if(type == 4) {
        var startDate = new Date();
        startDate.setDate(startDate.getDate()-7);
        // 近7天
        var startDate = pageUtils.dateFormat(startDate,'yyyy-MM-dd');
        var nowDate = pageUtils.dateFormat(nowDate,'yyyy-MM-dd');
        oneField.startDate = startDate;
        oneField.endDate = nowDate;
      } else {
        oneField.startDate = "";
        oneField.endDate = "";
      }
      this.outFieldArr = outFieldArr;
      that.$forceUpdate();
      that.getToHtData();
      this.$emit('loadDataInfo');
    },
    bindElementChangeLoad:function(fieldOne,type){
      this.bindElementChange(fieldOne,type);
      this.$emit('loadDataInfo');
    },
    openChangeDialog(filedInfo) {
      var flag = this.getDialogInfo(filedInfo);
      if(flag) {
        this.dialogInfo.sourceField = filedInfo;
        this.dialogInfo.ifOpen = true;
      }
    },
    getDialogInfo(filedInfo){
      var that = this;
      var flag = true;
      var clickPageId = 0;
      var clickTableId = 0;
      if (filedInfo.tcPageId > 0) {
        clickPageId = filedInfo.tcPageId
      }
      if (filedInfo.tcTableId > 0) {
        clickTableId = filedInfo.tcTableId
      }
      var tmpJsonData = "";
      if(flag) {
        var checkId = filedInfo.defaultCheckValue;
        var toListJson={
          pageId: clickPageId,
          tableId: clickTableId,
          initCheckId: checkId,
          callBackType:1,
          dataMaxNum: filedInfo.dataMaxNum,
          tmpJsonData: tmpJsonData,
          ifDialog:true,
        }
        that.toListJson = toListJson;
      }
      return flag;
    },
    /**
     * 关闭弹出层
     */
    closeDialog(){
      this.dialogInfo.ifOpen = false;
    },
    /**
     * 弹出层选中后的赋值回调事件
     */
    dialogClickCallBack(detail){
      var that = this;
      var clickValue = detail.val;
      var checkDataInfo = detail.checkDataInfo;
      var fieldSetIndexArr = this.dialogInfo.sourceField;
      console.log("fieldSetIndexArr==========================",fieldSetIndexArr);
      var prevDefaultCheckValue = fieldSetIndexArr.defaultCheckValue;
      pageUtils.bindDialogChangeByDataArr(fieldSetIndexArr,checkDataInfo);
      that.getToHtData();
      that.$forceUpdate();
      // 关闭弹出层
      that.dialogInfo.ifOpen = false;
    },
    /**
     * 清空搜索条件
     */
    clearSearchVal(){
      var outFieldArr = this.outFieldArr;
      var inFieldArr = this.inFieldArr;
      outFieldArr.forEach(one => {
        this.clearSearchOneVal(one);
      })
      inFieldArr.forEach(one => {
        this.clearSearchOneVal(one);
      })
      this.getToHtData();
      this.$emit('loadDataInfo');
    },
    clearSearchOneVal(fieldOne){
      var that = this;
      that.$set(fieldOne,"defaultCheckValueIndex",null);
      that.$set(fieldOne,"defaultCheckValue","");
      that.$set(fieldOne,"defaultCheckCnName","");
      that.$set(fieldOne,"defaultCheckIndexArr",[]);
      that.$set(fieldOne,"defaultValStr","");
      that.$set(fieldOne,"startValue","");
      that.$set(fieldOne,"endValue","");
      that.$set(fieldOne,"startDateObject",null);
      that.$set(fieldOne,"endDateObject",null);
      that.$set(fieldOne,"startDate","");
      that.$set(fieldOne,"endDate","");
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tabBox{margin: 10px;font-size: 16px;color: #BABABA;}
/* .filletBox{font-size: 16px;color: #BABABA;padding: 0 10px} */
.filletBox{font-size: 16px;color: #BABABA;}

.tabTitleBox{display: flex;margin: 5px 10px;font-size: 16px;color: #BABABA;justify-content: flex-start}
.SearchFrame{display: flex;margin: 0 10px;font-size: 16px;color: #BABABA;}
.tabName{padding-right: 10px;font-size: 14px;white-space: nowrap;text-overflow: ellipsis;width: 70px;}
.tabNameInput{line-height: 35px;padding-right: 10px;font-size: 14px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 70px;}
/* 日历 */
.calendar {
    background-color:white;  
    padding-top: 10px; 
}
.calendar-header{
  font-size: 16px;
  color: #EF3C00;
  background: #FEEDE5;
  padding: 5px 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin: 0;
}
.calendar-board{
  color: #323232;
  background: #FFFBF0;
}
.weeklyCalendarBox{margin: 10px 10px 0;border: 1px solid #F1F1F1;border-top-right-radius: 10px;border-top-left-radius: 10px;border-bottom: none;}
.searchIptBox{background: #ffffff;padding: 10px 0 15px;}
.searchIpt {
  font-size:14px;
  padding: 7px 0 7px 15px;
  background:#F0F0F0;
  color:#B0B8C1;
  display: flex;
  align-items: center;
  margin: 0 10px;
  border-radius:100px
}

/* .searchTit{display: inline-block;height: 36px;line-height: 36px;width:100%;} */
.searchTit{display: inline-block;vertical-align: middle;}
.iptPart{display: flex;justify-content: flex-start;align-items: center;position:relative;}
.iptPart .iconSearch {position:absolute;color:#919091;margin-right:3px;}
.searchInput{border: none;background: #F6F4F5;border-radius: 30px;padding: 3px 10px;font-size: 14px;box-sizing: border-box;color: #000}
.searchBtn::after{border: 0;outline: none}
.searchBtn{display: inline-block;border: 0;outline: none;padding: 0;vertical-align: bottom;margin: 0 10px;}
.searchAfterBtn::after{border: 0;outline: none}
.searchAfterBtn{display: inline-block;border: 0;outline: none;padding: 0;vertical-align: middle;margin: 0;background: #fff;font-size: 14px;border-radius: 34px;width: 65px}

.newUpImg img{width: 32px;height: 32px;margin-top: 8px}
.newUpImg img+view{ width: 75px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;}

.cancelBtn::after{border: 0;outline: none}
.cancelBtn{display: inline-block;border: 0;outline: none;padding: 0;vertical-align: middle;margin: 0 10px;background: none;font-size: 15px;color:#333}

.checkGroups {display: flex;flex-wrap: wrap;align-items: center;}
.checkItems {width:30%;padding:3px 10px;border:1px solid #666666;color:#666666;border-radius: 10px;box-sizing: border-box;margin-right: 9px;margin-bottom: 10px;display: flex;align-items: center;justify-content: center;}
.currentChecked {border:1px solid #F85F1B;color:#F85F1B;}
.btnBox {display:flex;}
.btnBox button {width:50%;border-radius:0;font-size:14px;}
.btnBox button::after {border: none;}
.btnBox .proSearchBtn {background:#EBEBEB;color:#636367}
.btnBox .proCancelBtn {background:#FA2A2A;color:#fff;}

.searchMore{height: 20px;line-height: 20px;text-align: center;display: inline-block;padding: 0;margin: 0 0 0 20px;font-size: 14px;background: #ffffff;color: #FA2021;vertical-align: middle;}
.searchMore::after{border:none}

.bottomBtn{display: flex;justify-items: center;width: 100%}

.hasScrollTip {display:flex;align-items: center;justify-content: center}
.hasScrollTip .scrollTipImg {flex:0 0 50px;text-align: center;font-size: 14px}
.scrollTipImg img {width:32px;margin-top: 8px}
.scrollTipImg .more {font-size: 14px;color: #BABABA;padding:6px 0 0  0;}
.botLine:before {content: ' ';border-bottom: 1px solid #EBEBEB;display: inline-block;position: absolute;bottom: 0;width:100%;z-index: 2;}
.rightDevid {position: relative}
.rightDevid:after {
  position: absolute;
  top: 50%;
  right: 0;
  content: '';
  display: block;
  width: 1px;
  height: 25px;
  background: #D6D6D6;
  transform: translateY(-15px)
}

.dateTitle{color: #1e1e1e;margin-bottom: 15px}
.allDate{margin-left: 10px}
.picker{text-align: center}
.understandBtn{background: #fff;color: #1e1e1e;font-size: 14px;width: 170px;padding: 10px 0;text-align: center;border: 1px solid #F8F8FA;border-radius: 5px}
.understandBtnBox{width: 355px;margin: 0 auto;display: flex;justify-content: space-between}
.understandBtnImg{width: 20px;height: 20px}

.cancel_btn{width: 50%}
.confirm_btn{width: 50%;background: #EE0A24;color: #fff}

.moreDropdownBox{position: absolute;left: 0;background: #fff;z-index: 1;}
.moreDropdownTop{padding: 10px}
.dateFlex{display: flex;justify-content: center;width: 100%}

.colorRed{color: #EE0A24}
.dateFlex .el-date-editor.el-input, .el-date-editor.el-input__inner{width: 150px}

  .more_dropdown{position: relative;padding: 10px}
  .el_input_search{margin: 0 10px;background: #F6F4F5;border-radius: 30px;height: 34px}
.select_name{color: rgba(0, 0, 0, 0.65);}
/*.selectBox{margin: 0 10px}*/
.vueSelectBox{width: 50%;text-align: center}
.cleck_more{margin-left: 10px;color: #C0C4CC;}
.kw_search{position: relative;}
.kw_search_default{
  border-radius:4px;border:1px solid #95ace4;background-color: #fafbfd;
}

</style>
<style>
  .select_search .el-input__inner{border:none;padding: 0 0 0 10px;}
  .el_input_search .el-input__inner{background: transparent;border: none;border-radius: 30px;height: 34px;line-height: 34px}
  .el_input_search .el-input__icon{line-height: 34px}
  .kw_search_default .el-input__inner{
    background-color: #fafbfd !important;
  }
</style>

